<template>
  <span id="view-cooler-inventory">
    <el-button
      id="btn-print-cooler-inventory"
      type="success"
      @click="handleOpenDialog"
      size="mini"
      class="margin-r-10"
      plain
    >
      {{ $t('coolerInventory.printButton') }}
    </el-button>
  <el-dialog
          :close-on-click-modal="false"
          v-on:open="handleOpen"
          :title="$t('coolerInventory.printTitle')"
          :visible.sync="dialogVisible"
          width="65%"
          class="dialog-with-cols"
          :before-close="handleClose">
  <el-form :model="printParams" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('coolerInventory.DOSFrom')" prop="dosFrom">
                  <el-date-picker
                          class="el-dropdown-new drop-sp date-dob"
                          v-model="printParams.dosFrom"
                          format="MM/dd/yyyy"
                          clearable
                          type="date"
                  ></el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('coolerInventory.DOSTo')" prop="dosTo">
                       <el-date-picker
                               class="el-dropdown-new drop-sp date-dob"
                               v-model="printParams.dosTo"
                               format="MM/dd/yyyy"
                               clearable
                               type="date"
                       ></el-date-picker>
              </el-form-item>
          </el-col>
              <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
               <el-form-item :label="$t('shipper.warehouse')" prop="warehouseId">
                <outbound-warehouse-select
                        class="dropdown-warehouse"
                        v-model="printParams.warehouseId"
                        :includeOptionAll="true">
                </outbound-warehouse-select>
              </el-form-item>
          </el-col>
      </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-print-button" @click="handlePrint()" size="mini">{{ $t('coolerInventory.print') }}</el-button>
      <el-button id="form-cancel-button" @click="dialogVisible = false"
                 size="mini">{{ $t('coolerInventory.cancel') }}</el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>

import { Message } from 'element-ui';
import constants from '@/utils/constants';

import OutboundWarehouseSelect from '@/views/routing/components/OutboundWarehouseSelect';

export default {
  name: 'PrintDialog',
  components: { OutboundWarehouseSelect },
  computed: {
    daysOptions() {
      return constants.DAYS_OPTIONS.filter(option => option.value != null);
    }
  },
  data() {
    return {
      dialogVisible: false,
      printParams: {
        warehouseId: null,
        dosFrom: new Date(),
        dosTo: new Date()
      },
      formRules: {
        dosFrom: [
          { required: true, message: this.$t('coolerInventory.error.dosFromRequired'), trigger: 'blur' },
        ],
        dosTo: [
          { required: true, message: this.$t('coolerInventory.error.toFromRequired'), trigger: 'blur' },
        ]
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
    },
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    resetForm() {
      this.printParams.warehouseId = null;
      this.printParams.dosFrom = new Date();
      this.printParams.dosTo = new Date();
    },
    handleClose(done) {
      done();
    },
    async handlePrint() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('coolerInventory/print', this.printParams)
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.resetForm();
                this.handleClose(true);
                resolve(response);
              })
              .catch(() => {
                loading.close();
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
    span#view-cooler-inventory {
        div.el-date-editor.el-dropdown-new, div.dropdown-warehouse.el-select--mini {
            width: 100%;
        }
    }
</style>
